$(document).ready(function () {
  //Sticky bar for product page
   $('.sticky-add-to-cart-btn').on('click', function() {
      $('.trigger-sticky-add-to-cart').trigger('click');
  });

  function updateStickyPrices() {
    // Get the first occurrence of the sale price
    var $salePriceElement = $('.price__pricing-group .price__sale .price-item--sale');
    
    var salePrice = $('.price__pricing-group .price__sale .price-item--sale').first().text().trim();

    // Get the first occurrence of the regular price
    var regularPrice = $('.price__pricing-group .price__sale .price-item--regular').first().text().trim();
    
    
    // Add the prices to the sticky sale section
    $('.price__sale.sticky .price-item--sale.sticky').text(salePrice);
    $('.price__sale.sticky .price-item--regular.sticky').text(regularPrice);


  }

  // Initial call to set the prices
  updateStickyPrices();

  // Update the prices when a variant is selected
  $(document).on('change', '.product-form .single-option-selector', function() {
      updateStickyPrices();

      // Get the first occurrence of the sale price
      var $salePriceElement = $('.price__pricing-group .price__sale .price-item--sale');

      if ($salePriceElement.is(':hidden')) {
        $('.price__sale.sticky').addClass('not-on-sale');
      } else {
        $('.price__sale.sticky').removeClass('not-on-sale');
      }

      // Keep sticky ATC state in sync when option dropdown changes
      syncStickyAddToCartState();
  });


  
  $('#Quantity-product-template').on('input change', function() {
        var quantity = $(this).val();

        // Check if the quantity is greater than 1
        if (quantity > 1) {
            $('.sticky-quantity').text('x ' + quantity);
        } else {
            // Optionally clear the sticky quantity if it's not greater than 1
            $('.sticky-quantity').text('');
        }
  });

  function syncStickyAddToCartState() {
      var $mainAddToCart = $('.trigger-sticky-add-to-cart');
      var $stickyAddToCart = $('.sticky-add-to-cart-btn');

      if (!$mainAddToCart.length || !$stickyAddToCart.length) return;

      var buttonText = $mainAddToCart.find('span[data-add-to-cart-text]').text().trim();
      var isDisabled = $mainAddToCart.is('[aria-disabled]');

      // Mirror main ATC text/state instead of hard-coding English strings.
      // Prevents the sticky label from getting stuck as sold out when variants change.
      $stickyAddToCart.toggleClass('sold-out', isDisabled);
      $stickyAddToCart.text(buttonText || (isDisabled ? 'Sold out' : 'Add to cart'));
  }

  function getProductSectionContainer() {
      return $('[data-section-type="product"], [data-section-type="product-template"]').first();
  }

  function getSelectedVariantFromProductJson() {
      var $section = getProductSectionContainer();
      if (!$section.length) return null;

      var sectionId = $section.attr('data-section-id');
      var productJsonEl = sectionId ? document.getElementById('ProductJson-' + sectionId) : null;

      if (!productJsonEl) {
          var fallback = $section.find('script[id^="ProductJson-"]').first();
          productJsonEl = fallback.length ? fallback[0] : null;
      }

      if (!productJsonEl) return null;

      var productData;
      try {
          productData = JSON.parse(productJsonEl.textContent || productJsonEl.innerHTML);
      } catch (e) {
          return null;
      }

      var $masterSelect = $section.find('select[name="id"][id^="ProductSelect-"]').first();
      var variantId = $masterSelect.length ? $masterSelect.val() : null;

      // BCPO keeps a hidden variant-id select as well; use it as a fallback.
      if (!variantId) {
          var $bcpoVariantSelect = $section.find('#bcpo-select, select[name="vopo-id"]').first();
          variantId = $bcpoVariantSelect.length ? $bcpoVariantSelect.val() : null;
      }

      if (!variantId || !productData || !Array.isArray(productData.variants)) return null;

      var match = productData.variants.find(function(v) {
          return String(v.id) === String(variantId);
      });

      return match || null;
  }

  function syncSoldOutBadgeFromSelectedVariant() {
      var $section = getProductSectionContainer();
      if (!$section.length) return;

      var variant = getSelectedVariantFromProductJson();
      if (!variant) return;

      // The sold-out badge visibility is controlled by `.price--sold-out` on `[data-price]`.
      $section.find('[data-price]').toggleClass('price--sold-out', !variant.available);
  }

  function requestSoldOutBadgeSync() {
      if (window.requestAnimationFrame) {
          window.requestAnimationFrame(syncSoldOutBadgeFromSelectedVariant);
      } else {
          setTimeout(syncSoldOutBadgeFromSelectedVariant, 0);
      }
  }

  // Initial sync on page load
  syncStickyAddToCartState();
  requestSoldOutBadgeSync();

  // Re-sync whenever variants change (slate.Variants/theme.Product)
  $(document).on('variantChange', function() {
      syncStickyAddToCartState();
      requestSoldOutBadgeSync();
  });

  // BCPO changes options without using the theme's `.single-option-selector-{{ section.id }}` classes,
  // so the theme's variant pipeline often doesn't run. Sync the sold-out badge after BCPO updates.
  $(document).on('change', '#bcpo select', function() {
      requestSoldOutBadgeSync();
  });
  
  //End Sticky Bar for product page

  // Function to detect Safari/iOS
  function isSafariIOS() {
    var ua = navigator.userAgent.toLowerCase();
    console.log("UA DEBUG: "+ ua);
    if(ua.includes('safari')) {
      console.log("safari detected");
      return true;
    } else if(/iphone|ipad|ipod/.test(ua)){
      console.log("iphone detected");
      return true;
    } else {
      return false;
    }    
  }

  var isSafari = isSafariIOS();

  // Store options for Safari/iOS
  var modelOptions = new Map();
  var seriesOptions = new Map();

  if (isSafari) {
    $('.model-selector > option').each(function() {
      var value = $(this).val();

      if (!modelOptions.has(value)) {
        modelOptions.set(value, $(this).clone());
      }
    });

    $('.series-selector > option').each(function() {
      var value = $(this).val();

      if (!seriesOptions.has(value)) {
        seriesOptions.set(value, $(this).clone());
      }
    });
  }
  

  // Function to set selectors based on cart attributes
  function setSelectors(make, model, series) {
    //console.log("set selectors "+make+" "+model+" "+series);
    if (make) {
      //console.log("make");
      $('.make-selector').val(make).change();
      $(".model-selector > option").each(function() {
        $(this).filter(function() {
          return $(this).attr("make") == make;
        }).show();
      });
    }

    if (model) {
      $('.model-selector').val(model).change();
      $(".series-selector > option").each(function() {
        $(this).filter(function() {
          return $(this).attr("model") == model;
        }).show();
      });
    }

    if (series) {
      $('.series-selector').val(series).change();
    }
  }

  // Get cart attributes and set selectors if they exist
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: 'json',
    success: function(d) {
      let attributes = d.attributes;
      let make = attributes.make || null;
      let model = attributes.model || null;
      let series = attributes.series || null;

      setSelectors(make, model, series);
    },
    error: function(xhr, status, error) {
      console.log("Failed to retrieve cart data:", status, error);
    }
  });

  // Handle variant change event
  $('.single-option-selector').change(function() {
    $('[data-tab-link-id="0"]').addClass('smart-tabs-navigation-li-active');
    $('#smart-tabs-content-0').addClass('smart-tabs-content-block-active');
  });

  // Function to hide all options except placeholders
  function hideAllOptions() {
    if (isSafari) {
      //console.log("safari hiding all options");
      $(".model-selector > option").not("[data=placeholder]").remove();
      $(".series-selector > option").not("[data=placeholder]").remove();
    } else {
      //console.log("non safari hiding all options");
      $(".model-selector > option").each(function() {
        $(this).not("[data=placeholder]").hide();
      });
      $(".series-selector > option").each(function() {
        $(this).not("[data=placeholder]").hide();
      });
    }
  }

  //HIDE ALL MODEL AND SERIES OPTIONS THAT ARE NOT THE TOP PLACEHOLDERS
  hideAllOptions();  

  
  $('.make-selector').each(function(){
    $(this).change(function () {
      let selector = $(this).val();

      if (isSafari) {
        //console.log("safari make changed, updating model and series options");
        // For Safari/iOS
        $(".model-selector > option").not("[data=placeholder]").remove();
        $(".model-selector").each(function() {
          $(this).val("").change();
        });
        $(".series-selector > option").not("[data=placeholder]").remove();
        $(".series-selector").each(function() {
          $(this).val("").change();
        });

        // Add options back based on the selected make
        modelOptions.forEach(function(option) {
          if ($(option).attr("make") == selector) {
            $(".model-selector").append(option.clone());
          }
        });

        // Clear series options as well
        $(".series-selector").each(function() {
          $(this).val("").change();
        });
      } else {
        //console.log("non safari make changed, updating model and series options");
        // For other browsers
        $(".model-selector > option").each(function() {
          $(this).not("[data=placeholder]").hide();
        });
        $(".model-selector").each(function() {
          $(this).val("").change();
        });
        $(".series-selector > option").each(function() {
          $(this).not("[data=placeholder]").hide();
        });
        $(".series-selector").each(function() {
          $(this).val("").change();
        });

        $(".model-selector > option").each(function() {
          if ($(this).attr("make") == selector) {
            $(this).show();
          }
        });

        $(".series-selector > option").each(function() {
          if ($(this).attr("make") == selector) {
            $(this).show();
          }
        });
      }
    });
  });

  $('.model-selector').each(function() {
    $(this).change(function() {
      let selector = $(this).val();

      if (isSafari) {
        //console.log("safari model changed, updating series options");
        // For Safari/iOS
        $(".series-selector > option").not("[data=placeholder]").remove();
        $(".series-selector").each(function() {
          $(this).val("").change();
        });

        // Add options back based on the selected model
        seriesOptions.forEach(function(option) {
          if ($(option).attr("model") == selector) {
            $(".series-selector").append(option.clone());
          }
        });
      } else {
        //console.log("non safari model changed, updating series options");
        // For other browsers
        $(".series-selector > option").not("[data=placeholder]").hide();
        $(".series-selector").val("").change();
        $(".series-selector > option").filter(function() {
          return $(this).attr("model") == selector;
        }).show();
      }
    });
  });

  $('.vehicle-selector').submit(function( event ) {
    event.preventDefault();
    url = $(this).find(".series-selector").find(":selected").attr("url");
    if(url === undefined) {
      url = $(this).find(".model-selector").find(":selected").attr("url");
    }
    if(url === undefined) {
      url = $(this).find(".make-selector").find(":selected").attr("url");
    }
    if(url === undefined) {
      url = "https://ppdperformance.com.au/collections/all";
    }
    
    vehicle_url = url;
    
    partTypeFilter = $(this).find(".part-type-selector").find(":selected").val();
    if(partTypeFilter !== undefined && partTypeFilter !== "") {
      url = url + "?attributes.product_type=" + partTypeFilter;
    }

    var series = $(this).find(".series-selector").find(":selected").val();
    var model = $(this).find(".model-selector").find(":selected").val();
    var make = $(this).find(".make-selector").find(":selected").val();
    var handle = $(this).find(".series-selector").find(":selected").attr("handle");
    if(handle === undefined) {
      handle = $(this).find(".model-selector").find(":selected").attr("handle");
    }

    if(handle === undefined) {
      if(url) {
        window.location.href = url;
      } else {
        window.location.href = "https://ppdperformance.com.au/collections/all";   
      }
    }

    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[series]": series, 
             "attributes[model]": model, 
             "attributes[make]": make,
             "attributes[handle]": handle,
             "attributes[vehicle_url]": vehicle_url},
      success: function(d){
        if(url) {
          window.location.href = url;
        }
      },
      error: function(xhr, status, error) {
        console.error("AJAX Error:", status, error);
        if(url) {
          window.location.href = url;
        }
      },
      dataType: 'json'
    });

    
  });

  $('.remove-vehicle').click(function(event) {
    event.preventDefault();

    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[series]": "", 
             "attributes[model]": "", 
             "attributes[make]": "",
             "attributes[handle]": "",
             "attributes[vehicle_url]": ""}, 
      success: function(d) {
        window.location.href = "/";
      },
      error: function(xhr, status, error) {
        console.error("AJAX Error:", status, error);
      },
      dataType: 'json'
    });
  });
});
